// @ts-nocheck
import { createAuthRequiredPage } from "wasp/client/app"

// These files are used from user-land and the import paths below are relative to the
// user's project dir, and not the SDK:
import LandingPage from './src/landing-page/LandingPage'
import AboutPage from './src/legal/AboutPage'
import PrivacyPolicyPage from './src/legal/PrivacyPolicyPage'
import TermsOfServicePage from './src/legal/TermsOfServicePage'
import ImpressumPage from './src/legal/ImpressumPage'
import LoginPage from './src/auth/LoginPage'
import { Signup as SignupPage } from './src/auth/SignupPage'
import { RequestPasswordResetPage } from './src/auth/email-and-pass/RequestPasswordResetPage'
import { PasswordResetPage } from './src/auth/email-and-pass/PasswordResetPage'
import { EmailVerificationPage } from './src/auth/email-and-pass/EmailVerificationPage'
import AccountPage from './src/user/AccountPage'
import PricingPage from './src/payment/PricingPage'
import CheckoutPage from './src/payment/CheckoutPage'
import AdminOverviewPage from './src/admin/dashboards/overview/OperationsOverviewPage'
import AnalyticsDashboardPage from './src/admin/dashboards/analytics/AnalyticsDashboardPage'
import AdminUsersPage from './src/admin/dashboards/users/UsersDashboardPage'
import { NotFoundPage } from './src/client/components/NotFoundPage'
import AdminMessagesPage from './src/messages/MessagesPage'
import AdminArticlesPage from './src/admin/dashboards/articles/ArticlesDashboardPage'
import AdminFeedsPage from './src/admin/dashboards/feeds/FeedsDashboardPage'
import { FlaggedArticlesDashboardPage } from './src/admin/dashboards/flagged/FlaggedArticlesDashboardPage'
import NewsletterPage from './src/newsletter/NewsletterPage'
import NewsletterUnsubscribePage from './src/newsletter/NewsletterUnsubscribePage'
import NewsletterConfirmPage from './src/newsletter/NewsletterConfirmPage'
import { TodayPage } from './src/today/TodayPage'
import ArticlesPage from './src/articles/ArticlesPage'
import { TrendsPage } from './src/trends/TrendsPage'
import { ActivityPage } from './src/activity/ActivityPage'
import { RecapPage } from './src/recap/RecapPage'
import { CreateDiscussionPage } from './src/discussions/CreateDiscussionPage'
import { DiscussionsPage } from './src/discussions/DiscussionsPage'
import { DiscussionPage } from './src/discussions/DiscussionPage'
import { ProfilePage } from './src/profile/ProfilePage'

export const routesMapping = {
  LandingPageRoute: LandingPage,
  AboutRoute: AboutPage,
  PrivacyPolicyRoute: PrivacyPolicyPage,
  TermsOfServiceRoute: TermsOfServicePage,
  ImpressumRoute: ImpressumPage,
  LoginRoute: LoginPage,
  SignupRoute: SignupPage,
  RequestPasswordResetRoute: RequestPasswordResetPage,
  PasswordResetRoute: PasswordResetPage,
  EmailVerificationRoute: EmailVerificationPage,
  AccountRoute: createAuthRequiredPage(AccountPage),
  PricingPageRoute: PricingPage,
  CheckoutRoute: createAuthRequiredPage(CheckoutPage),
  AdminRoute: createAuthRequiredPage(AdminOverviewPage),
  AdminAnalyticsRoute: createAuthRequiredPage(AnalyticsDashboardPage),
  AdminUsersRoute: createAuthRequiredPage(AdminUsersPage),
  NotFoundRoute: NotFoundPage,
  AdminMessagesRoute: createAuthRequiredPage(AdminMessagesPage),
  AdminArticlesRoute: createAuthRequiredPage(AdminArticlesPage),
  AdminFeedsRoute: createAuthRequiredPage(AdminFeedsPage),
  FlaggedArticlesRoute: createAuthRequiredPage(FlaggedArticlesDashboardPage),
  NewsletterRoute: createAuthRequiredPage(NewsletterPage),
  NewsletterUnsubscribeRoute: NewsletterUnsubscribePage,
  NewsletterConfirmRoute: NewsletterConfirmPage,
  TodayRoute: TodayPage,
  ArticlesRoute: ArticlesPage,
  TrendsRoute: TrendsPage,
  ActivityRoute: createAuthRequiredPage(ActivityPage),
  RecapRoute: createAuthRequiredPage(RecapPage),
  CreateDiscussionRoute: createAuthRequiredPage(CreateDiscussionPage),
  DiscussionsRoute: DiscussionsPage,
  DiscussionRoute: DiscussionPage,
  ProfileRoute: ProfilePage,
} as const;
